import { render, staticRenderFns } from "./ApplicantsSelectionKorolev.vue?vue&type=template&id=833ec08a&"
import script from "./ApplicantsSelectionKorolev.vue?vue&type=script&lang=js&"
export * from "./ApplicantsSelectionKorolev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports